import { App } from '@capacitor/app'
import { PluginListenerHandle } from '@capacitor/core'
import { useEffect } from 'react'

export function useRefetchOnFocusOrOnline(callback: () => void) {
    function handleCallback() {
        callback()
    }

    useEffect(() => {
        window.addEventListener('online', handleCallback)
        const appStateListener: Promise<PluginListenerHandle> = App.addListener(
            'appStateChange',
            ({ isActive }) => isActive && handleCallback()
        )

        return () => {
            window.removeEventListener('online', handleCallback)
            appStateListener.then((handle) => handle.remove())
        }
    }, [callback])
}
